/**
 * Zendesk Messaging: one place for snippet + authenticated identity.
 */
import { zendesk as zendeskApi } from "apis-v2/callables";

/**
 * Tell Zendesk who the current user is (external_id = our uid) when authenticated.
 * Call logoutUser first so Zendesk clears any previous visitor state and applies the full JWT identity (including email).
 */
export function identifyZendesk() {
    if (!window.zE) return;
    try {
        window.zE("messenger", "logoutUser");
    } catch (_e) {
        // ignore if no session
    }
    window.zE("messenger", "loginUser", callback => {
        zendeskApi.getJwt({})
            .then(({ jwt }) => jwt && callback(jwt))
            .catch(() => {
                // ignore - unauthenticated or missing config
            });
    });
}

/**
 * Clear Zendesk user state on logout so the next visitor is anonymous.
 */
export function logoutZendesk() {
    if (window.zE) {
        try {
            window.zE("messenger", "logoutUser");
        } catch (_e) {
            // ignore Zendesk API errors on logout
        }
    }
}

// Partial (zendesk.ejs) runs first and defines zendeskInit; it can't import our bundle.
// We set this when our module loads (after app.js runs). zendeskInit() is only *called*
// when the user opens the widget (after app has loaded), so window.identifyZendesk is set by then.
if (typeof window !== "undefined") {
    window.identifyZendesk = identifyZendesk;
}
